'use strict';
angular.module('sysmanageRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('manageconfig.sysmanage.classifieddictionary', {
                // 分类词典
                url: '/classifieddictionary',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/classifiedDictionary/main_tpl.html',
                        controller: 'cDMainCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.sensitiveword', {
                // 敏感词
                url: '/sensitiveword',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/sensitiveWord/sensitiveWordMge_tpl.html',
                        controller: 'sysManageMentSensitiveWordCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.soucenclassifymgr', {
                // 资源中心分类管理
                url: '/soucenclassifymgr',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/resourceCenterClassifyMgr/resourceCenterClassifyMgr_tpl.html',
                        controller: 'manConSysSouCenClassifyMgrCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.emailconfig', {
                // 邮件设置
                url: '/emailconfig',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/emailConfig/emailConfig_tpl.html',
                        controller: 'manageSysManageEmailConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.smsgatewayconfig', {
                // 短信网关设置
                url: '/smsgatewayconfig',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/SMSGatewayConfig/SMSGatewayConfig_tpl.html',
                        controller: 'manageSysManageSMSGatewayConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.sourcemanage', {
                // 来源管理
                url: '/sourcemanage',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/sourceManage/sourceManage_tpl.html',
                        controller: 'manageSysManageSourceManageCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.plandispatch', {
                // 计划调度
                url: '/plandispatch',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/planDispatch/planDispatch_tpl.html',
                        controller: 'manageSysManagePlanDispatchCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.hotwordsmanage', {
                // 热词管理
                url: '/hotwordsmanage',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/hotWordsManage/hotWordsManage_tpl.html',
                        controller: 'manageSysManageHotWordsManageCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.statusmanage', {
                // 状态管理
                url: '/statusmanage',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/statusManage/statusManage_tpl.html',
                        controller: 'manageSysManageStatusManageCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.releasecomponentmanage', {
                // 发布组件管理
                url: '/releasecomponentmanage',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/releaseComponentManage/releaseComponentManage_tpl.html',
                        controller: 'manageSysManageReleaseComponentManageCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.smstempconfig', {
                // 短信模板设置
                url: '/smstempconfig',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/SMSTempConfig/SMSTempConfig_tpl.html',
                        controller: 'manageSysManageSMSTempConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.emailtempconfig', {
                // 邮件模板设置
                url: '/emailtempconfig',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/emailTempConfig/emailTempConfig_tpl.html',
                        controller: 'manageSysManageEmailTempConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.otherconfiguration', {
                // 其他配置
                url: '/otherconfiguration',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/otherConfiguration/otherConfiguration_tpl.html',
                        controller: 'manageSysManageOtherConfigurationCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.systemfield', {
                // 系统字段
                url: '/systemfield',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/systemField/systemField_tpl.html',
                        controller: 'manageSysManageSystemFieldCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.typemgr', {
                // 稿库类型管理
                url: '/typemgr',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/typeMgr/typeMgr_tpl.html',
                        controller: 'manageSysManageTypeMgrCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.categorymgr', {
                // 稿库类别管理
                url: '/categorymgr',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/categoryMgr/categoryMgr_tpl.html',
                        controller: 'manageSysManageCategoryMgrCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.publicmateriallibrary', {
                // 公共素材库
                url: '/publicmateriallibrary',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/publicMaterialLibrary/publicMaterialLibrary_tpl.html',
                        controller: 'manageSysManagePublicMaterialLibraryCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.manuscriptattributeconfig', {
                // 广电文稿属性配置
                url: '/manuscriptattributeconfig',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/manuscriptAttributeConfig/manuscriptAttributeConfig_tpl.html',
                        controller: 'manageSysManageManuscriptAttributeConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.categoryrelation', {
                // 稿库类别关联
                url: '/categoryrelation',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/categoryRelation/categoryRelation_tpl.html',
                        controller: 'manageSysManageCategoryRelationCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.comlibrarymanagement', {
                // 组件库管理
                url: '/comlibrarymanagement',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/comLibraryManagement/comLibraryManagement_tpl.html',
                        controller: 'manageSysManageComLibraryManagementCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.sysoperationmanagement', {
                // 运营管理
                url: '/sysoperationmanagement',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/sysOperationManagement/sysOperationManagement_tpl.html',
                        controller: 'manageSysManageSysOperationManagementCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.systemmanagementmodule', {
                // 系统管理模块
                url: '/systemmanagementmodule',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/systemManagementModule/systemManagementModule_tpl.html',
                        controller: 'manageSysManagesyStemManagementModuleCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.personalcentermodule', {
                // 个人中心管理模块
                url: '/personalcentermodule',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/personalCenterConfig/personalCenterConfig_tpl.html',
                        controller: 'manageSysManagesyStemPersonalCenterConfigCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.xhsgcircuit', {
                // 新华社稿线路配置
                url: '/xhsgcircuit',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/xhsgCircuit/xhsgCircuit_tpl.html',
                        controller: 'manageSysXhsgCircuitCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.tenantsharemanuscript', {
                // 租户间共享
                url: '/tenantsharemanuscript',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/tenantShareManuscript/main_tpl.html',
                        controller: 'tenantShareManuscriptCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.cooperationgroup', {
                // 个人中心管理模块
                url: '/cooperationgroup?objectid&maxsortnum',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/tenantShareManuscript/cooperationGroup/main_tpl.html',
                        controller: 'cooperationGroupCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.hiddencodemanagement', {
                // 个人中心管理模块
                url: '/hiddencodemanagement',
                views: {
                    'main@manageconfig.sysmanage': {
                        template: '<div ui-view="main"></div>',
                    },
                },
            })
            .state('manageconfig.sysmanage.systemnotice', {
                // 系统公告
                url: '/systemnotice',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/systemNotice/systemNotice_tpl.html',
                        controller: 'systemNoticeCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.contributionQuery', {
                // 稿件查询
                url: '/contributionQuery',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/contributionQuery/contributionQuery_tpl.html',
                        controller: 'manageSysManageContributionQueryCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.XHContributionAccessRecords', {
                // 新华社稿取用记录
                url: '/XHContributionAccessRecords',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/XHContributionAccessRecords/XHContributionAccessRecords_tpl.html',
                        controller: 'manageSysManageXHContributionAccessRecordsCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.feedback', {
                // 意见反馈
                url: '/feedback',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/feedback/feedback_tpl.html',
                        controller: 'manageSysManageFeedBackCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.syncsign', {
                // 端网自动同签管理
                url: '/syncsign',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/syncSign/syncSign_tpl.html',
                        controller: 'manageSysManageSyncSignCtrl',
                    },
                },
            })
            .state('manageconfig.sysmanage.NacosConfig', {
                // 大数据平台配置
                url: '/NacosConfig',
            })
            .state('manageconfig.sysmanage.syncsign.editsyncsign', {
                url: '/editsyncsign?relid',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/syncSign/EditSyncSign/EditSyncSign_tpl.html',
                        controller: 'manageSysManageEditSyncSignCtrl',
                    },
                },
            }).state('manageconfig.sysmanage.peopleMark', {
                url: '/peopleMark',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/mediaTag/template/mediaTag_tpl.html',
                        controller: 'peopleMarkCtrl',
                    },
                },
            }).state('manageconfig.sysmanage.placeMark', {
                url: '/placeMark',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/mediaTag/template/mediaTag_tpl.html',
                        controller: 'placeMarkCtrl',
                    },
                },
            }).state('manageconfig.sysmanage.eventMark', {
                url: '/eventMark',
                views: {
                    'main@manageconfig.sysmanage': {
                        templateUrl: './manageConfig/sysManageMent/mediaTag/template/mediaTag_tpl.html',
                        controller: 'eventMarkCtrl',
                    },
                },
            });
    },
]);
